import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import Disclaimers
  from '../Content/Disclaimers/Disclaimers';

export default buildFacetDesignOverride()
  .nameOverride('disclaimers', {
    _component: () => Disclaimers,
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => Richtext,
  }, overrideReadOnly);
